module.exports = __webpack_public_path__ + "img/zzf_board_person2.0ffdb116.png";